import { Activity } from './icons/Activity'
import { AddWithBorder } from './icons/AddWithBorder'
import { Address } from './icons/Address'
import { AddressBook } from './icons/AddressBook'
import { Alert } from './icons/Alert'
import { Appendix } from './icons/Appendix'
import { At } from './icons/At'
import { Baoming } from './icons/Baoming'
import { BellSimpleZ } from './icons/BellSimpleZ'
import { Bottom } from './icons/Bottom'
import { BottomTriangle } from './icons/BottomTriangle'
import { Branch } from './icons/Branch'
import { Calendar } from './icons/Calendar'
import { CalendarCheck } from './icons/CalendarCheck'
import { CallBell } from './icons/CallBell'
import { Ceyan } from './icons/Ceyan'
import { CheckCircleFill } from './icons/CheckCircleFill'
import { CheckMark } from './icons/CheckMark'
import { Clock } from './icons/Clock'
import { Close } from './icons/Close'
import { Copy } from './icons/Copy'
import { Cuohao } from './icons/Cuohao'
import { Delete } from './icons/Delete'
import { DeviceTabletSpeaker } from './icons/DeviceTabletSpeaker'
import { Devices } from './icons/Devices'
import { DownMove } from './icons/DownMove'
import { Download } from './icons/Download'
import { Drag } from './icons/Drag'
import { DragVertical } from './icons/DragVertical'
import { DriveFile } from './icons/DriveFile'
import { Edit } from './icons/Edit'
import { Elevator } from './icons/Elevator'
import { Email } from './icons/Email'
import { Expand } from './icons/Expand'
import { Eye } from './icons/Eye'
import { Fenxiang4 } from './icons/Fenxiang4'
import { File } from './icons/File'
import { Fold } from './icons/Fold'
import { Fuzhi } from './icons/Fuzhi'
import { Gender } from './icons/Gender'
import { Gengduo } from './icons/Gengduo'
import { Gonggao } from './icons/Gonggao'
import { Guardian } from './icons/Guardian'
import { HalfRight } from './icons/HalfRight'
import { Help } from './icons/Help'
import { Home } from './icons/Home'
import { Huodong } from './icons/Huodong'
import { IdCard } from './icons/IdCard'
import { InfoCircleFill } from './icons/InfoCircleFill'
import { Jiahao } from './icons/Jiahao'
import { Jiaohuan } from './icons/Jiaohuan'
import { Kecheng } from './icons/Kecheng'
import { Left } from './icons/Left'
import { LeftArrow } from './icons/LeftArrow'
import { Luopan } from './icons/Luopan'
import { Menhu } from './icons/Menhu'
import { Menus } from './icons/Menus'
import { Mianshi } from './icons/Mianshi'
import { Minus } from './icons/Minus'
import { MultipleChoice } from './icons/MultipleChoice'
import { Num } from './icons/Num'
import { Paging } from './icons/Paging'
import { Paper } from './icons/Paper'
import { Phone } from './icons/Phone'
import { Picture } from './icons/Picture'
import { Plus } from './icons/Plus'
import { Record } from './icons/Record'
import { Refresh } from './icons/Refresh'
import { Right } from './icons/Right'
import { RightArrow } from './icons/RightArrow'
import { RightTriangle } from './icons/RightTriangle'
import { Search } from './icons/Search'
import { Setting } from './icons/Setting'
import { Shanchu } from './icons/Shanchu'
import { Shangchuanwenjian } from './icons/Shangchuanwenjian'
import { Shuaxin } from './icons/Shuaxin'
import { Single } from './icons/Single'
import { Siren } from './icons/Siren'
import { Student } from './icons/Student'
import { Table } from './icons/Table'
import { Teacher } from './icons/Teacher'
import { Tianjia } from './icons/Tianjia'
import { Time } from './icons/Time'
import { Top } from './icons/Top'
import { UnorderedList } from './icons/UnorderedList'
import { UpMove } from './icons/UpMove'
import { Upload } from './icons/Upload'
import { User } from './icons/User'
import { WarnFill } from './icons/WarnFill'
import { Wenjuan } from './icons/Wenjuan'
import { WrongMark } from './icons/WrongMark'
import { Xiaoyan } from './icons/Xiaoyan'
import { Xiazai } from './icons/Xiazai'
import { Xinxi } from './icons/Xinxi'
import { Yanjing } from './icons/Yanjing'
import { Yaohao } from './icons/Yaohao'
import { YonghuShangchuan } from './icons/YonghuShangchuan'
import { YonghuTianjia } from './icons/YonghuTianjia'
import { YonghuZu } from './icons/YonghuZu'
import { Zhibo } from './icons/Zhibo'
import { Zhongqianrenshu } from './icons/Zhongqianrenshu'
import { Zongrenshu } from './icons/Zongrenshu'

export const iconParkMap = {
  At,
  Edit,
  Plus,
  Minus,
  Single,
  UnorderedList,
  Record,
  MultipleChoice,
  Appendix,
  Calendar,
  CalendarCheck,
  Num,
  Time,
  Address,
  AddressBook,
  Table,
  Paging,
  Help,
  LeftArrow,
  Eye,
  Drag,
  Copy,
  Delete,
  DriveFile,
  WarnFill,
  DragVertical,
  Clock,
  Close,
  User,
  Picture,
  Phone,
  IdCard,
  Guardian,
  Gender,
  Email,
  Branch,
  CallBell,
  Huodong,
  Fenxiang4,
  Yanjing,
  Shanchu,
  Fuzhi,
  Jiaohuan,
  Jiahao,
  Wenjuan,
  Ceyan,
  Kecheng,
  Gonggao,
  Zhibo,
  Baoming,
  BellSimpleZ,
  Mianshi,
  Yaohao,
  Gengduo,
  Xiazai,
  Shangchuanwenjian,
  YonghuZu,
  YonghuShangchuan,
  Tianjia,
  YonghuTianjia,
  Right,
  Search,
  Menus,
  Refresh,
  Bottom,
  Cuohao,
  Top,
  CheckMark,
  WrongMark,
  Zongrenshu,
  Zhongqianrenshu,
  Luopan,
  Shuaxin,
  Siren,
  Xiaoyan,
  CheckCircleFill,
  AddWithBorder,
  HalfRight,
  UpMove,
  DownMove,
  Paper,
  Setting,
  Teacher,
  Student,
  Activity,
  DeviceTabletSpeaker,
  Devices,
  Download,
  File,
  RightArrow,
  Menhu,
  Fold,
  Elevator,
  Expand,
  Alert,
  Home,
  Upload,
  BottomTriangle,
  RightTriangle,
  Left,
  InfoCircleFill,
  Xinxi,
}

export type IconParkName = keyof typeof iconParkMap

export interface IconParkSVGWrapperProps extends IconProps {
  // 图标名称
  name: IconParkName
  hoverColor?: string
  text?: string
  textMarginLeft?: string | number
  wrapperStyle?: React.CSSProperties
}

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  // 大小
  size?: string | number
  // 宽
  width?: string | number
  // 高
  height?: string | number
  // 是否旋转
  spin?: boolean
  // 是否左右翻转
  rtl?: boolean
  // 图标颜色
  color?: string
  // 图标填充色
  fill?: string
  // 图标描边
  stroke?: string
}

export interface BaseIconProps extends React.SVGProps<SVGSVGElement> {
  _width?: string | number
  _height?: string | number
  _fill?: string
  spin?: boolean
  rtl?: boolean
}
